'use client';

import {
  FaFacebookF,
  FaHeart,
  FaInstagram,
  FaLinkedinIn,
  FaRegHeart,
  FaStar,
  FaXTwitter,
  FaYoutube,
} from 'react-icons/fa6';
import ProductGallery from './ProductGallery';
import TabMenu from './TabMenu';
import { useAppDispatch, useAppSelector } from '@/lib/redux/hooks';
import { addItem, updateQuantity } from '@/lib/redux/features/cart';
import { toggleWishlistItem } from '@/lib/redux/features/wishlist';
import { useEffect, useState } from 'react';
import { HiOutlineBadgeCheck } from 'react-icons/hi';
const ProductDetailsTop = () => {
  const dispatch = useAppDispatch();
  const wishlistItems = useAppSelector((state) => state.wishlist.items);
  const cartItems = useAppSelector((state) => state.cart.items);

  interface CartItem {
    id: string;
    title?: string;
    imgSrc?: string;
    price: number;
    rating?: number;
    reviews?: number;
    quantity: number;
    categories?: string;
  }
  const [data, setData] = useState<CartItem>({
    id: '5',
    title: 'Fresh Pumpkin',
    imgSrc: '/images/product/popular/10.png',
    price: 31.0,
    rating: 4.7,
    reviews: 87,
    categories: 'Features',
    quantity: 1,
  });

  const handleClick = () => {
    dispatch(addItem({ ...data, quantity: 1 }));
  };

  const decreaseQuantity = (id: string) => {
    const item = cartItems.find((cartItem) => cartItem.id === id);
    if (item && item.quantity > 1) {
      dispatch(updateQuantity({ id, quantity: item.quantity - 1 }));
    }
  };

  const increaseQuantity = (id: string) => {
    const item = cartItems.find((cartItem) => cartItem.id === id);
    if (item) {
      dispatch(updateQuantity({ id, quantity: item.quantity + 1 }));
    } else {
      // If item is not in the cart yet, add it
      dispatch(addItem({ ...data, quantity: 1 }));
    }
  };
  useEffect(() => {
    if (cartItems.length > 0) {
      const newCartItems = cartItems.find((item) => item.id === data.id);
      if (newCartItems) {
        setData(newCartItems);
      }
    }
  }, [cartItems]);

  return (
    <section className="product-details padding-top padding-bottom ">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12">
            <div className="product-details">
              <div className="row g-5">
                <ProductGallery />
                <div className="col-md-6 col-12">
                  <div className="post-content">
                    <h2>
                      Fresh and Organic Mixed Berries for Healthy Delights
                    </h2>
                    <p className="rating">
                      <FaStar />
                      <FaStar />
                      <FaStar />
                      <FaStar />
                      <FaStar />
                      (56 Reviews)
                    </p>
                    <div className="post-content__price">
                      <h2>$49.50</h2>
                      <del>$55.00</del>
                      <span>(8% off)</span>
                    </div>
                    <div className="post-content__brand">
                      Brand: <span>Torganic</span>
                    </div>
                    <ul className="post-content__list">
                      <li>
                        <div>
                          <HiOutlineBadgeCheck />
                        </div>
                        <p>
                          Lowers bad cholesterol, supports cardiovascular
                          wellness.
                        </p>
                      </li>
                      <li>
                        <div>
                          <HiOutlineBadgeCheck />
                        </div>
                        <p>
                          Rich in vitamins, minerals, promoting overall health.
                        </p>
                      </li>
                      <li>
                        <div>
                          <HiOutlineBadgeCheck />
                        </div>
                        <p>Aids in satiety, beneficial for weight control.</p>
                      </li>
                      <li>
                        <div>
                          <HiOutlineBadgeCheck />
                        </div>
                        <p>
                          Delivery might delay due to some external dependency
                        </p>
                      </li>
                    </ul>
                    <div className="post-content__btn btn-group">
                      <div className="quantity-button">
                        <button
                          onClick={() => decreaseQuantity(data.id)}
                          className="quantity-button__control quantity-button__control--decrease"
                        >
                          -
                        </button>
                        <span className="quantity-button__display">
                          {data.quantity}
                        </span>
                        <button
                          onClick={() => increaseQuantity(data.id)}
                          className="quantity-button__control quantity-button__control--increase"
                        >
                          +
                        </button>
                      </div>
                      <span
                        onClick={handleClick}
                        className="trk-btn trk-btn--primary"
                      >
                        Add to Cart
                      </span>
                      <a
                        style={{ cursor: 'pointer' }}
                        onClick={() => dispatch(toggleWishlistItem(data))}
                        className="product-details__fav-btn"
                      >
                        {wishlistItems?.some((item) => item.id === '5') ? (
                          <FaHeart color="red" />
                        ) : (
                          <FaRegHeart />
                        )}
                      </a>
                    </div>
                    <div className="post-content__social">
                      <h4>Share with:</h4>
                      <ul className="social">
                        <li className="social__item">
                          <a
                            aria-label="Facebook"
                            href="#"
                            className="social__link"
                          >
                            <FaFacebookF />
                          </a>
                        </li>
                        <li className="social__item">
                          <a
                            href="#"
                            className="social__link"
                            aria-label="social link"
                          >
                            <FaInstagram />
                          </a>
                        </li>
                        <li className="social__item">
                          <a
                            href="#"
                            className="social__link"
                            aria-label="social link"
                          >
                            <FaLinkedinIn />
                          </a>
                        </li>
                        <li className="social__item">
                          <a
                            href="#"
                            className="social__link"
                            aria-label="social link"
                          >
                            <FaYoutube />
                          </a>
                        </li>
                        <li className="social__item">
                          <a
                            href="#"
                            className="social__link"
                            aria-label="social link"
                          >
                            <FaXTwitter />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <TabMenu />
      </div>
    </section>
  );
};

export default ProductDetailsTop;
